import { Services } from "@/services/services.ts";
import { LocationHook } from "preact-iso";

export class Url {
  static route: LocationHook['route'];

  static navigateOutside = (url: string) => {
    if (typeof window !== "undefined") {
      window.location.assign(url);
    }
  }

  static setRoute(route: LocationHook['route']) {
    Url.route = route;
  }

  static getQueryParams(query: string): URLSearchParams {
    return new URLSearchParams(query);
  }

  static getQueryParam(paramName: string, query: string): string | null {
    const queryParams = Url.getQueryParams(query);

    return queryParams.get(paramName);
  }

  static to(name: string, params: object = {}, search?: string): string {
    const parameters = Services.instance.parameters;
    // fix toMenuItem bug
    const prepared = parameters.prepareForUrl({
      language: parameters.parameters?.language ?? "en",
    });
    const allParams = {
      ...params,
      ...prepared,
    };
    const routePath = Services.instance.router.getRoutePathByName(name)!;
    const routeParamsKeys = Services.instance.router.getRouteParamsFromPath(routePath);
    const queryParams = Url.filterQueryParamsFromPassedParams(allParams, routeParamsKeys);
    const urlpath = Url.buildUrlPath(routePath, allParams);

    const url = new URL(urlpath, window.location.origin);

    if (search) {
      const searchParams = new URLSearchParams(search);
      searchParams.forEach((value, key) => {
        url.searchParams.append(key, value);
      });
    }

    queryParams.forEach((key) => {
      // @ts-ignore
      url.searchParams.append(key, allParams[key]);
    });

    return url.toString();
  }

  static getRoutePathByRouteLocation(location: any) {
    let routePath = "";
    location.routes.forEach((route: any) => {
      routePath += route.path;
    });
    routePath = routePath.replace("//", "/");

    return routePath + location.search;
  }

  static filterQueryParamsFromPassedParams(passed: Record<string, any>, routeParamsKeys: string[]) {
    return Object.keys(passed).filter((param) => !routeParamsKeys.includes(param));
  }

  static buildUrlPath(pattern: string, params: Record<string, string | string[] | undefined>) {
    const segments = pattern.split("/");
    const result: string[] = [];

    for (const segment of segments) {
      if (segment.startsWith(":")) {
        const isOptional = segment.endsWith("?");
        const isSplat = segment.endsWith("*") || segment.endsWith("+");
        const name = segment.slice(1, segment.length - (isOptional || isSplat ? 1 : 0));

        const value = params[name];

        if (value === undefined) {
          if (isOptional || isSplat) continue;
          throw new Error(`Missing value for "${name}"`);
        }

        if (Array.isArray(value)) {
          if (!isSplat) throw new Error(`Param "${name}" must not be array`);
          result.push(...value.map(encodeURIComponent));
        } else {
          result.push(encodeURIComponent(value));
        }
      } else {
        result.push(segment);
      }
    }

    return "/" + result.filter(Boolean).join("/");
  }

  static normalizeRoute = (route: string) => {
    route = route.replace(/\/{2,}/g, "/");

    if (route.startsWith("/")) {
      route = route.slice(1);
    }

    if (route.endsWith("/")) {
      route = route.slice(0, -1);
    }

    return route;
  };
}
